import { Component, Input } from "@angular/core";

import {
  NgbModal,
  NgbModalOptions,
  ModalDismissReasons,
} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "childmodal",
  moduleId: module.id,
  templateUrl: "childmodal.component.html",
  styleUrls: ["./childmodal.component.scss"],
})
// tslint:disable-next-line:component-class-suffix
export class ChildModal {
  @Input() public allBrothersData?: any;
  @Input() public child: any;
  @Input() public nest?: any;
  @Input() public eventMeshutaf?: any;
  public closeResult: string;
  public messages: any;

  constructor(private modalService: NgbModal) {
    this.messages = JSON.parse(localStorage.getItem("messages"));
  }

  public open(content) {
    const options: NgbModalOptions = {
      windowClass: "modal-opened",
      backdrop: "static",
    };
    this.modalService.open(content, options).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  public getModalTitle() {
    if (this.child && this.child.firstName) {
      return (
        this.child.firstName + " " + this.child.lastName + " - " + "עריכת פרטים"
      );
    } else {
      return "הוספת ילד/ה";
    }
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/child/childmodal.component.ts